<div class="tw-w-full tw-overflow-hidden tw-rounded-lg tw-bg-white tw-shadow-sm">
  <div class="tw-grid tw-w-full tw-grid-cols-[auto_1fr]">
    <div class="tw-bg-gray-50 tw-p-4">
      <p class="tw-m-0 tw-font-inter tw-text-xs tw-font-semibold tw-uppercase tw-leading-normal tw-text-gray-500 tw-whitespace-nowrap">
        <span class="lg:tw-hidden">Tracker<br />Label</span>
        <span class="tw-hidden lg:tw-inline">Tracker label</span>
      </p>
    </div>
    <div class="tw-bg-gray-50 tw-p-4">
      <p class="tw-m-0 tw-font-inter tw-text-xs tw-font-semibold tw-uppercase tw-leading-normal tw-text-gray-500 tw-whitespace-nowrap">
        What it means
      </p>
    </div>

    <div class="tw-col-span-2 tw-h-px tw-bg-gray-200"></div>

    @for (row of rows(); track row.label; let odd = $odd) {
      <div class="tw-p-4" [ngClass]="rowClass(odd)">
        <p class="tw-m-0 tw-whitespace-nowrap tw-font-inter tw-text-sm tw-font-semibold tw-leading-normal tw-text-gray-900">
          {{ row.label }}
        </p>
      </div>
      <div class="tw-p-4" [ngClass]="rowClass(odd)">
        <p class="tw-m-0 tw-font-inter tw-text-sm tw-font-normal tw-leading-normal tw-text-gray-500 tw-whitespace-normal">
          {{ row.meaning }}
        </p>
      </div>
    }
  </div>
</div>
